export const phoneFormat = (number: string) =>
  `${number ?? ''}`
    .replace(/[^\d]+/g, '')
    .replace(/^\+?(\d{2})(\d{2})(\d{4,5})(\d{4})$/g, `+$1 ($2) $3-$4`);
